var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75V2C4 0.895431 4.89543 0 6 0H8C9.10457 0 10 0.895431 10 2V2.75H12.5C12.9142 2.75 13.25 3.08579 13.25 3.5C13.25 3.91421 12.9142 4.25 12.5 4.25H12V12C12 13.1046 11.1046 14 10 14H4C2.89543 14 2 13.1046 2 12V4.25H1.5C1.08579 4.25 0.75 3.91421 0.75 3.5C0.75 3.08579 1.08579 2.75 1.5 2.75H4ZM5.5 2.5H8.5V2C8.5 1.72386 8.27614 1.5 8 1.5H6C5.72386 1.5 5.5 1.72386 5.5 2V2.5ZM3.5 4.25H10.5V12C10.5 12.2761 10.2761 12.5 10 12.5H4C3.72386 12.5 3.5 12.2761 3.5 12V4.25Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGray);
export default __webpack_public_path__ + "static/media/trashGray.1af2f04b94f1596a6adc93b574ddfe23.svg";
export { ForwardRef as ReactComponent };